export const initialCaensState = {
    caens: [],
};
  
export interface ICaensState {
    caens: any[],
}
  